var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49565 4.66683H4.66231L8.86231 13.5218L7.28731 16.3685C6.43565 17.9318 7.55565 19.8335 9.32898 19.8335H22.1623C22.804 19.8335 23.329 19.3085 23.329 18.6668C23.329 18.0252 22.804 17.5002 22.1623 17.5002H9.32898L10.6123 15.1668H19.304C20.179 15.1668 20.949 14.6885 21.3456 13.9652L25.5223 6.3935C25.954 5.6235 25.394 4.66683 24.5073 4.66683H7.24065L6.45898 2.9985C6.27231 2.59016 5.85231 2.3335 5.40898 2.3335H3.49565C2.85398 2.3335 2.32898 2.8585 2.32898 3.50016C2.32898 4.14183 2.85398 4.66683 3.49565 4.66683ZM9.32898 21.0002C8.04565 21.0002 7.00731 22.0502 7.00731 23.3335C7.00731 24.6168 8.04565 25.6668 9.32898 25.6668C10.6123 25.6668 11.6623 24.6168 11.6623 23.3335C11.6623 22.0502 10.6123 21.0002 9.32898 21.0002ZM18.674 23.3335C18.674 22.0502 19.7123 21.0002 20.9956 21.0002C22.279 21.0002 23.329 22.0502 23.329 23.3335C23.329 24.6168 22.279 25.6668 20.9956 25.6668C19.7123 25.6668 18.674 24.6168 18.674 23.3335Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.b1c841d277003db89b249a835613636f.svg";
export { ForwardRef as ReactComponent };